


























import { Component, Prop, Vue } from 'vue-property-decorator';
import CartDiscounts from '@/components/Cart/Discounts.vue';
import { TotalSegment } from '@/store/models';
import cart from '@/store/modules/cart';
import checkout from '@/store/modules/checkout';

@Component({
  components: {
    CartDiscounts
  },
})
export default class TotalsComp extends Vue {
  @Prop() private totalSegments!: TotalSegment[];

  get loading(): boolean {
    return cart.loadingFlags.totals;
  }

  get amountForFreeShipping(): number {
    if (cart.totals.extension_attributes && cart.totals.extension_attributes.amount_to_freeshipping) {
      return cart.totals.extension_attributes.amount_to_freeshipping;
    }
    return 0;
  }

  get amountForFreeShippingFromatted() {
    return Vue.filter('currency')(this.amountForFreeShipping);
  }

  public canShow(totalSegment: TotalSegment) {
    const notShowable = [
      'fidelity_discount',
      'gift_discount', // #45638 show gift discount into component Discounts
      'discount', // #45638 show discount into component Discounts
    ];
    if (totalSegment.code === 'shipping') {
      return checkout.selectedShipment && checkout.selectedShipment.toString() !== '';
    }
    return totalSegment.value
      && totalSegment.value !== 0
      && !notShowable.includes(totalSegment.code);
  }

  get isVipQuote(): boolean {
    return cart.cart.extension_attributes && cart.cart.extension_attributes.is_vip_cart;
  }

  get sortedTotals(): TotalSegment[] {
    const totals = this.totalSegments;
    const sort: any = {
      subtotal: 10,
      cashondelivery_incl_tax: 15,
      discount: 20,
      gift_discount: 30,
      shipping: 50,
      customerbalance: 90,
      reward: 95,
      grand_total: 99,
      default: 999,
    };
    totals.sort((a: TotalSegment, b: TotalSegment) => {
      const pa = sort[a.code] || sort.default;
      const pb = sort[b.code] || sort.default;
      if (pa < pb) {
        return -1;
      }
      if (pb < pa) {
        return 1;
      }
      return 0;
    });
    return totals;
  }

  public getTitle(totalSegment: TotalSegment): any {
    switch (true) {
      case totalSegment.code === 'grand_total':
        return this.$t('Total');

      case totalSegment.code === 'shipping':
        return this.isVipQuote ? this.$t('Shipping and handling') : this.$t('Shipping');

      case totalSegment.title === 'Sconto (Fidelity card)':
        return this.$t('Glam card discount');

      case totalSegment.code === 'gift_discount':
        return this.$t('giftcardmsg', {code: checkout.giftCard.code});

      default:
        return totalSegment.title;
    }
  }
}
